import React, { useEffect } from "react";

const data = [
  {
    id: 0,
    name: "Rajesh Singh",
    img: "/images/team/rajesh.jpeg",
    designation: "Director & COO",
    about:
      "He is a seasoned logistics professional with nearly 20 years of experience in leading strategic business verticals and initiatives. Throughout his career, he has demonstrated exceptional leadership skills, driving growth and innovation in various logistics-related domains. His expertise spans multiple facets of the industry, and his visionary approach has been instrumental in shaping successful business outcomes. With a proven track record of success, he  is a respected leader in the logistics sector, known for his strategic acumen and dedication to excellence.",
  },
  {
    id: 1,
    name: "Vishal Mehta",
    img: "",
    designation: "Advisor",
    about:
      "Vishal is a seasoned executive with over 20 years of experience in leading business operations and driving turnaround strategies. He has a proven track record of success, having worked as a top performer in diverse sectors such as Banking, Insurance, and Tyres. With a unique blend of industry expertise and leadership acumen, Vishal has consistently delivered results and excelled in challenging environments. His expertise includes:- Business Operations Management- Turnaround Strategies- Team Leadership- Performance Optimization. Mr. Vishal's extensive experience and multidisciplinary background make him a valuable asset to any organization",
  },
  {
    id: 2,
    name: "Manav Lohia",
    img: "/images/team/manav.jpeg",
    designation: "Advisor",
    about:
      "Manav is a seasoned professional with 25 years of experience in business operations, spanning international and Indian markets. He has a unique expertise in managing channel partner relationships, having worked with various organizations in:- Truck OEM (Original Equipment Manufacturer) - Logistics- IoT (Internet of Things)- Tech & E-commerce. Throughout his career, Manav has demonstrated a keen ability to navigate diverse markets, foster strong partnerships, and drive business growth. His extensive experience has equipped him with a deep understanding of the complexities of global and local markets, making him a valuable asset to any organization seeking to expand its reach and revenue.",
  },
  
];

const Team = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <div className="careers-hero">
        <img
          src="https://images.pexels.com/photos/3856042/pexels-photo-3856042.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
          alt=""
        />
        <div
          className="row position-absolute  align-items-end p-lg-5 w-100"
          style={{ top: "150px" }}
        >
          <div className="col col-12  px-lg-5">
            <p className="fs-6 text-dark mt-5 fw-bold"></p>
            <h1 className="text-light mb-4">
              People come first in our lively, inclusive, and entrepreneurial
              culture. <i className="text-lora"> Love your future.</i>
            </h1>

            <div className="d-flex pb-5 px-5 px-lg-0">
              <button className="btn btn-outline-light btn-lg px-5 border-3 rounded-5">
                View current openings{" "}
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="section-header">
          <h2>
            Meet our <i className="text-lora">team</i>
          </h2>
        </div>
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 my-4 row-gap-4">
          {data?.map((member, i) => (
            <div className="col">
              <img
                src={member?.img || "/images/team/profile_placeholder.png"}
                alt=""
                className="w-100 team-profile-img"
              />
              <div className="p-3 bg-black text-white">
                <h4 className="fw-bold">{member?.name}</h4>
                <h6>{member?.designation}</h6>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Team;
